import React, { FC } from 'react';
import { Skeleton } from '@mantine/core';

const DiseaseSkeleton: FC = () => {
  return <Skeleton radius={8} h={334} />;
};

export default DiseaseSkeleton;
